import styled from 'styled-components';

export const MessageActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionWrapper = styled.div`
  cursor: pointer;
  padding-top: 3px;
  font-size: 2rem;
  transition: color 0.3s ease;

  &:hover {
    color: var(--brand-primary);
  }
`;

export const CustomIcon = styled.span.attrs({
  className: 'icon-option-vertical',
  'data-testid': 'messageActionBar',
})`
  color: var(--gray-dark);
  font-size: 18px;
  cursor: pointer;

  &:hover {
    color: var(--brand-primary);
  }
  &.active {
    color: var(--brand-primary);
  }
`;

export const ListGroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  transition: background 0.2s ease;
  color: var(--brand-primary);

  &:hover {
    background: #f5f5f5;
    color: var(--brand-primary);
  }

  &:last-child {
    border-bottom: none;
  }

  .uikit-icon {
    font-size: 16px;
  }
`;
